// DEV-1686: тело шаблона WhatsApp Business содержит нумерованные плейсхолдеры
// `{{1}}`, `{{2}}` — Meta нумерует их с единицы и по порядку.
const PLACEHOLDER_RE = /\{\{(\d+)\}\}/g

/** Сколько параметров ждёт шаблон (наибольший номер плейсхолдера в body). */
export function templateParamCount(body?: string): number {
  if (!body) return 0
  let max = 0
  for (const match of body.matchAll(PLACEHOLDER_RE)) {
    max = Math.max(max, Number(match[1]))
  }
  return max
}

/**
 * Подставляет параметры в body шаблона для предпросмотра и оптимистичного
 * сообщения в ленте. Незаполненный плейсхолдер остаётся как есть — менеджер
 * видит, что именно не хватает.
 */
export function renderTemplateBody(body: string | undefined, params: string[]): string {
  if (!body) return ''
  return body.replace(PLACEHOLDER_RE, (token, index) => params[Number(index) - 1] || token)
}
